export const checkImageUrlExists = async (url: string): Promise<boolean> => {
    if (!url) {
        return false;
    }

    return new Promise((resolve) => {
        const img = new Image();

        const timeout = setTimeout(() => {
            resolve(false);
        }, 5000);

        img.onload = () => {
            clearTimeout(timeout);
            resolve(true);
        };
        img.onerror = () => {
            clearTimeout(timeout);
            resolve(false);
        };

        img.src = url;
    });
};
